module.exports = __webpack_public_path__ + "img/Telegram.99d5e71f.png";